import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { ColorModeProvider } from './context/ColorModeContext';
import ThemeBar from './components/ThemeBar';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Products from './pages/Products';
import Innovation from './pages/Innovation';
import Sustainability from './pages/Sustainability';
import ScrollToQuery from './components/ScrollToQuery';
import ScrollToHash from './components/ScrollToHash';
import ScrollPerf from './components/ScrollPerf';

function ThemedToast() {
  const { theme } = useTheme();
  return <ToastContainer position="bottom-right" theme={theme.toast} />;
}

function DevThemeBar() {
  const show =
    typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('dev') === '1';
  if (!show) return null;
  return <ThemeBar />;
}

export default function App() {
  return (
    <ThemeProvider>
      <ColorModeProvider>
          <BrowserRouter>
            <a href="#main" className="skip-nav">
              Skip to content
            </a>
            <ScrollToQuery />
            <ScrollToHash />
            <ScrollPerf />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/innovation" element={<Innovation />} />
              <Route path="/sustainability" element={<Sustainability />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <DevThemeBar />
            <ThemedToast />
          </BrowserRouter>
      </ColorModeProvider>
    </ThemeProvider>
  );
}
